import { replacePathParams } from '@/api/utils';

export const userApiPaths = {
  profile: '/apicomposer/me',
  preferences: '/userservice/users/preferences',
  settingsById: '/communicationservice/settings/:userId',
  resendInvite: '/userservice/users/:userId/resend',
  changeEmail: '/userservice/users/change-email',
  verifyEmail: '/userservice/users/verify-email',
} as const;

export const getUserApiUrl = {
  profile: userApiPaths.profile,
  preferences: userApiPaths.preferences,
  settingsById: (userId: string) => replacePathParams(userApiPaths.settingsById, { userId }),
  resendInvite: (userId: string) => replacePathParams(userApiPaths.resendInvite, { userId }),
  changeEmail: (userId: string) => replacePathParams(userApiPaths.changeEmail, { userId }),
  verifyEmail: (userId: string) => replacePathParams(userApiPaths.verifyEmail, { userId }),
};
